import React,{useState} from 'react'
import {db,auth} from './firebase'
import './styles/submission.css'

export default function Submission({data}) {
    const [user,setUser]=useState(null)
    //====================================================
    //adding data to firebase
    //====================================================
    //getting user data
    const userData=()=>{
        auth.onAuthStateChanged((user)=>{
            if(user){
                setUser(user.email)
            }
            else{
                alert("Please Login")
            }
        })
    }

    userData()
    const addDataFirebase=()=>{
        let docName=data.problem.contestId+data.problem.index
        
        console.log('user Data fetched')
        db.collection(user).doc('data').collection('problems').doc(docName).set({
            contest_id:data.problem.contestId,
            name:data.problem.name,
            prob_id:data.problem.index,
            rating:data.problem.rating,
            url:`http://codeforces.com/problemset/problem/${data.problem.contestId}/${data.problem.index}`
        })
        console.log('data added')
        alert("Problem Added")
    }










    let url=`http://codeforces.com/problemset/problem/${data.problem.contestId}/${data.problem.index}`

    return (
        <div className='container'>
        <i class="material-icons" onClick={addDataFirebase}>add</i>
        <h3>{data.problem.contestId+data.problem.index}</h3>
        <h3 id='name'>{data.problem.name}</h3>
        <h3>{data.problem.rating}</h3>
        <a href={url} target='_blank'> <i class="material-icons" id='link'>launch</i></a>
        </div>
    )
}
// <h3>{data.rating}</h3>
// <h3 id='name'>{problem.name}</h3>
// <h3>{problem.rating}</h3>
// <a href={problem.url} target='_blank'> <i class="material-icons" id='link'>launch</i></a>